// extracted by mini-css-extract-plugin
module.exports = {"header__title":"Center_header__title__KrIZ_","header__icon":"Center_header__icon__MoTmQ"};